import React from 'react';

export function TradingViewChart({ symbol, height }: { symbol: string; height: string }) {
  const params = new URLSearchParams({
    symbol,
    interval: '60',
    theme: 'dark',
    style: '1',
    locale: 'id',
    timezone: 'Asia/Jakarta',
    withdateranges: '1',
    hide_side_toolbar: '0',
    allow_symbol_change: '1',
    save_image: '1',
    studies: '',
    utm_source: 'cuantrader',
  });

  return (
    <div
      data-testid="tradingview-widget"
      className="w-full rounded-2xl overflow-hidden border border-white/10 bg-[#090D1A]"
      style={{ height, minHeight: 440 }}
    >
      <iframe
        key={symbol}
        title={`TradingView chart ${symbol}`}
        src={`https://s.tradingview.com/widgetembed/?${params.toString()}`}
        className="w-full h-full border-0"
        allow="fullscreen"
      />
    </div>
  );
}
